// extracted by mini-css-extract-plugin
export default {"content-text":"confirm-layout_content-text__9fEj2"};